/**
 * Client-side feature flags.
 *
 * Set a flag to `true` to enable the feature, `false` to disable it.
 * Each flag gates both the UI entry point (nav item, button, etc.) and the
 * corresponding route so the feature is unreachable from either direction.
 */
export const FEATURE_FLAGS = {
  /** Social Media analytics dashboard (/a/arche_social_media/analytics) */
  socialMediaAnalytics: true,
  /** Allow adding Instagram accounts as competitor sources */
  instagramCompetitors: false,
} as const;
